import * as z from "zod";

export const getCoverageProductIds = {
  name: "getCoverageProductIds" as const,
  input: z.null(),
  output: z.object({
    /** Numeric Shopify product ids of the team's Redo coverage products. */
    redoCoverageProductIds: z.array(z.string()),
  }),
};
